import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import BaseButton from "./BaseButton";

const BaseModal = ({
  className,
  bodyClassName,
  size,
  footerClassName,
  open,
  onClose,
  children,
  title,
  toggle,
  submit,
  closeLabel,
  submitLabel,
  closeLabelColor,
  submitLabelColor,
  loader,
  isSubmitDisabled,
}) => {
  return (
    <Modal
      isOpen={open}
      toggle={toggle}
      size={size}
      className={className}
      centered
    >
      {title && (
        <ModalHeader toggle={toggle} className="p-3 bg-soft-success">
          {title}
        </ModalHeader>
      )}

      <ModalBody className={bodyClassName}>{children}</ModalBody>

      <ModalFooter className={footerClassName}>
        {submit && (
          <BaseButton
            color={submitLabelColor}
            onClick={submit}
            disable={isSubmitDisabled}
            loader={loader}
          >
            {submitLabel}
          </BaseButton>
        )}

        {toggle && (
          <BaseButton color={closeLabelColor} onClick={toggle} className="me-2">
            {closeLabel}
          </BaseButton>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default BaseModal;
